var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1 -1 48 48",
    id: "Notes-Tasks--Streamline-Ultimate.svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Notes Tasks Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.1875 8.625h7.1875c0.76245 0 1.4938500000000001 0.30291 2.0330083333333335 0.8420683333333334S40.25 10.737511666666666 40.25 11.5v30.1875c0 0.76245 -0.30283333333333334 1.4938500000000001 -0.8419916666666667 2.0330083333333335s-1.2705583333333335 0.8419916666666667 -2.0330083333333335 0.8419916666666667h-28.75c-0.7624883333333333 0 -1.4937733333333334 -0.30283333333333334 -2.032931666666667 -0.8419916666666667C6.052910000000001 43.18135 5.75 42.44995 5.75 41.6875V11.5c0 -0.7624883333333333 0.30291 -1.4937733333333334 0.8420683333333334 -2.032931666666667C7.131226666666667 8.92791 7.862511666666666 8.625 8.625 8.625h7.1875c0 -1.9062400000000002 0.7572558333333334 -3.734414166666667 2.105170833333333 -5.082329166666667C19.26556666666667 2.1947558333333332 21.093683333333335 1.4375 23 1.4375c1.9063166666666669 0 3.7344333333333335 0.7572558333333334 5.082425 2.105170833333333C29.430225000000004 4.890585833333334 30.1875 6.7187600000000005 30.1875 8.625Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    d: "M23 8.625c-0.3969416666666667 0 -0.71875 -0.3217891666666667 -0.71875 -0.71875s0.3218083333333333 -0.71875 0.71875 -0.71875",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    d: "M23 8.625c0.3969416666666667 0 0.71875 -0.3217891666666667 0.71875 -0.71875S23.39694166666667 7.1875 23 7.1875",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.9375 20.125H23",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.75 20.125h4.3125",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.0625 27.3125H23",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 27.3125H12.9375",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.9375 34.5H23",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.75 34.5h4.3125",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/media/icon-projects.308b6a9000688fb13af28e0e425f6e63.svg";
export { ForwardRef as ReactComponent };